<!--
 * @ Author: Your name
 * @ Create Time: 2019-06-20 09:49:39
 * @ Modified by: Your name
 * @ Modified time: 2019-08-07 13:47:56
 * @ Description: 退料记录
 -->
<template>
  <div class="content-wrapper">
    <el-form
      label-width="100px" label-position="right" ref="searchForm" :model="formData.data"
      class="search-form" :inline="true">
      <div class="grid-wrapper">
        <el-form-item label="退料时间" prop="rejectTime">
          <el-date-picker
            v-model="rejectTime"
            size='small'
            type="datetimerange"
            range-separator="-"
            format="yyyy-MM-dd HH:mm:ss"
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="退料单号" prop="rejectedPersonPhone" class="inputWidth160">
          <el-input
            size="small" v-model="formData.data.rejectedNumber"
            placeholder="退料单号" clearable class=""/>
        </el-form-item>
        <el-form-item label="退料状态" prop="recordStatus" class="inputWidth160">
            <el-select v-model="formData.data.recordStatus" size="small"
              placeholder="" class="" clearable>
              <el-option value="" label="全部"></el-option>
              <el-option v-for="(item, index) in recordStatusList"
                :key="index"
                :value="item.value"
                :label="item.label">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="退料员手机号" prop="rejectedPersonPhone" class="inputWidth160">
          <el-input
            size="small" v-model="formData.data.rejectedPersonPhone"
            placeholder="退料员手机号" clearable class=""/>
        </el-form-item>
        <el-form-item label="领取退料配送员手机号" prop="receivePersonPhone" class="width180">
          <el-input
            size="small" v-model="formData.data.receivePersonPhone"
            placeholder="领取退料配送员手机号" clearable class="inputWidth130"/>
        </el-form-item>
        <el-form-item label="领取时间" prop="receiveTime">
          <el-date-picker
            v-model="receiveTime"
            size='small'
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="飞机号" prop="aircraftNumber" class="inputWidth160">
          <el-input
            size="small" v-model="formData.data.aircraftNumber"
            placeholder="飞机号" clearable class=""/>
        </el-form-item>
        <el-form-item label="工卡指令号" prop="jobCardNumber" class="inputWidth160">
          <el-input
            size="small" v-model="formData.data.jobCardNumber"
            placeholder="工卡指令号" clearable class=""/>
        </el-form-item>
        <el-form-item label="智能柜编号" prop="deviceNumber" class="inputWidth160">
          <el-input
            size="small" v-model="formData.data.deviceNumber"
            placeholder="智能柜编号" clearable/>
        </el-form-item>
        <el-form-item label="柜门号" prop="cabinetDoorName" class="width180">
          <el-input
            size="small" v-model="formData.data.cabinetDoorName"
            placeholder="柜门号" clearable class="inputWidth130"/>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" size="small" class="btn160"
            @click="searchTableData" icon="el-icon-search"
            :loading="loadingSearch">查询</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="tool-bar">
      <el-button class="download" size="small" icon="el-icon-download"
        @click="downLoadList" :loading="downLoading">下载列表</el-button>
      <el-button type="warning" size="small" icon="el-icon-user"
        @click="handleBtn('updateDeliveryManTel')">变更配送员手机号</el-button>
      <el-button type="success" size="small" icon="el-icon-message"
        @click="reSendShotMessage()">重发短信</el-button>
      <el-button type="primary" size="small" icon="el-icon-edit"
        @click="editPhone()">退料通知手机号配置</el-button>
    </div>
    <span class="tips">( 提示：只有退料状态为已入柜才可以变更配送人手机号和重发短信 )</span>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      :loading='tableLoading'
      :isCheckbox='isCheckbox'
      service
      @service-fn="handleService"
      @row-click="rowClick"
      @selection-change='selectionChange'
      >
      <el-table-column
        :selectable='isDisabled'
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column prop="deviceNumber" label="智能柜编号" align="center"
        show-overflow-tooltip min-width="120"/>
      <el-table-column prop="deviceName" label="智能柜名称" align="center"
        show-overflow-tooltip min-width="120"/>
      <el-table-column prop="cabinetDoorName" label="柜门号" align="center" show-overflow-tooltip/>
      <el-table-column prop="rejectedPersonName" label="退料员" align="center" show-overflow-tooltip/>
      <el-table-column prop="rejectedPersonPhone" label="退料员手机号" align="center"
        show-overflow-tooltip min-width="120"/>
      <el-table-column prop="rejectedNumber" label="退料单号" align="center"
        min-width="140" show-overflow-tooltip/>
      <el-table-column prop="rejectedTime" label="退料时间" align="center" :formatter='formatterTime'
        show-overflow-tooltip min-width="160"/>
      <el-table-column prop="recordStatus" label="退料状态" align="center" show-overflow-tooltip
        :formatter='formatterRecordStatus'/>
      <el-table-column prop="receivePersonPhone" label="领取退料配送员手机号"
        align="center" show-overflow-tooltip width="165"/>
      <el-table-column prop="actualReceiveName" label="实际领取人" align="center"
        show-overflow-tooltip width="110"/>
      <el-table-column prop="actualReceivePhone" label="实际领取人手机号" align="center"
        show-overflow-tooltip min-width="135"/>
      <el-table-column prop="receiveTime" label="领取时间" align="center" :formatter='formatterTime'
        show-overflow-tooltip min-width="160"/>
      <el-table-column prop="deliveryNumber" label="领取人变更状态" align="center"
        show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span class="updateStatus" @click.stop="viewUpdateStatus(scope.row.id)">
            {{formatUpdateStatus(scope.row.exchangeStatus)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryNumber" label="退料单详细信息" align="center"
        show-overflow-tooltip width="130">
        <template slot-scope="scope">
          <span class="updateStatus" @click.stop="viewRecordStatus(scope.row.id)">
            查看详细信息
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="rejectedPhoto" label="退料员照片" align="center"
        show-overflow-tooltip width="110">
        <template slot-scope="scope">
          <viewer v-if="scope.row.rejectedPhoto !=='' && scope.row.rejectedPhoto !=='null'">
            <img :src="arrayBufferToBase64(scope.row.rejectedPhoto)" class="imgs">
          </viewer>
        </template>
      </el-table-column>
      <el-table-column prop="receivePhoto" label="配送员照片" align="center"
        show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <viewer v-if="scope.row.receivePhoto !=='' && scope.row.receivePhoto !=='null'">
            <img :src="arrayBufferToBase64(scope.row.receivePhoto)" class="imgs">
          </viewer>
        </template>
      </el-table-column>
    </table-pagination>
    <!-- 这是变更领取人弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="mainDialogVisible"
      width="480px"
      >
      <dialog-main ref="dialogForm"
        :type="tableTypes"
        :id="dialogId"
        :receivePersonPhone='receivePersonPhone'
        :visible='mainDialogVisible'></dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mainDialogVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm()" size="small" type="primary">确定</el-button>
      </span>
    </el-dialog>
    <!-- 这是领取人变更弹窗内容 -->
    <el-dialog title="查看变更领取人记录"
      :visible.sync="updataStatusVisible"
      width="680px">
      <el-table :data="updataStatusTabledata"
        border :height="400" class="updateStatusTable">
        <el-table-column property="receivePersonPhone"
          label="变更前领取人手机号" width="150" align="center"/>
        <el-table-column property="exchangePhone"
          label="变更后领取人手机号" width="150" align="center"/>
        <el-table-column property="updateDate"
          label="变更时间" align="center" :formatter='formatterTime'/>
        <el-table-column property="updateBy" label="操作人" align="center"/>
      </el-table>
    </el-dialog>
    <!-- 这是配送单详细信息 -->
    <el-dialog title="查看配送单详细信息"
      :visible.sync="recordDetailsVisible"
      width="780px">
      <el-table :data="recordDetailsData"
        border :height="400" class="updateStatusTable">
        <el-table-column property="aircraftNumber" width="110"
          label="飞机号" align="center"/>
        <el-table-column property="workcardNumber" width="180"
          label="工卡指令号" align="center"/>
        <el-table-column property="issueNumber" width="180"
          label="发料单号" align="center"/>
        <el-table-column property="materialName" show-overflow-tooltip
          label="发料件号及申请退料数" align="center">
          <template scope="scope">
            {{scope.row.materialName}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 退料通知手机号配置 -->
    <el-dialog title="退料通知手机号配置"
      :visible.sync="editPhoneVisible"
      width="480px">
        <el-form :inline="true" :model='editPhoneForm' class="dialog-wrapper"
          label-width="150px" :rules="rulesEditPhone" ref="editPhoneEl">
          <el-form-item label="原手机号" prop='preNoticePhone'>
            <el-input class="editPhone" v-model="editPhoneForm.preNoticePhone"
              placeholder="原手机号" size="small" clearable disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop='noticePhone'>
            <el-input class="editPhone" v-model="editPhoneForm.noticePhone"
              placeholder="手机号" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editPhoneVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="editPhoneConfim()" size="small" type="primary">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tables from '../../mixins/table'
import { STORERETURNRECORD } from '../../libs/api'
import handleBtn from '../../mixins/dialog/handleBtn'
import dialogMain from './dialogMain.vue'
import { saveFile } from '../../libs/utils/file'
import { correctPhone } from '../../libs/utils/validCheck'

export default {
  name: 'storesReturnedRecord',
  mixins: [tables, handleBtn],
  components: {
    dialogMain
  },
  data() {
    return {
      isCheckbox: true,
      tableTypes: 'storesReturnedRecord',
      tableLoading: false,
      loadingSearch: false,
      downLoading: false,
      rulesEditPhone: {
        noticePhone: [{ required: true, message: '请输入手机号', trigger: 'change' },
          { validator: correctPhone, trigger: 'blur' }]
      },
      recordStatusList: [{
        value: 1,
        label: '已入柜'
      }, {
        value: 0,
        label: '已取消'
      }, {
        value: 2,
        label: '已领取'
      }],
      dic: {
        exchangeStatus: {
          1: '未变更',
          2: '已变更'
        },
        recordStatus: {
          0: '已取消',
          1: '已入柜',
          2: '已领取'
        }
      },
      receiveTime: '',
      rejectTime: '',
      editPhoneForm: {
        noticePhone: '',
        preNoticePhone: ''
      },
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          deviceNumber: '',
          cabinetDoorName: '',
          aircraftNumber: '',
          rejectedPersonPhone: '',
          receivePersonPhone: '',
          jobCardNumber: '',
          recordStatus: '',
          rejectedNumber: ''
        }
      },
      recordStatusCancel: 1,
      receivePersonPhone: '',
      updataStatusVisible: false,
      recordDetailsVisible: false,
      editPhoneVisible: false,
      updataStatusTabledata: [],
      recordDetailsData: [],
      searchUrl: STORERETURNRECORD.GET_LIST,
      findhistoryUrl: STORERETURNRECORD.FINDHISTORY,
      downLoadListUrl: STORERETURNRECORD.DOWNLOAD,
      updateUrl: STORERETURNRECORD.UPDATE,
      inserRecordUrl: STORERETURNRECORD.INSERTRECORD,
      finleRecordListUrl: STORERETURNRECORD.RECORDFINDLIST,
      reSendUrl: STORERETURNRECORD.RESEND,
      editPhoneUrl: STORERETURNRECORD.EDITPHONE,
      getSystemConfigUrl: STORERETURNRECORD.GETSYSTEMCONFIG
    }
  },
  mounted() {
    this.searchTableData()
  },
  watch: {
    editPhoneVisible(val) { // 重置“退料通知手机号配置”校验
      if (val && this.$refs.editPhoneEl) {
        this.$refs.editPhoneEl.resetFields()
      }
    }
  },
  methods: {
    searchTableData() {
      this.formatFormData()
      // this.$http.post(this.searchUrl, this.formData)
      this.handleSearch(this.searchUrl, this.formData)
    },
    formatFormData() {
      // 将配送时间、取件时间 拆分成两个时间
      const params = ['rejectTime', 'receiveTime']
      const tempTime = {
        rejectTime1: 'rejectStartTime',
        rejectTime2: 'rejectEndTime',
        receiveTime1: 'receiveStartTime',
        receiveTime2: 'receiveEndTime'
      }
      params.forEach(item => {
        if (this[item]) {
          /* eslint-disable */ 
          this.formData.data[tempTime[`${item}1`]] = this[item][0]
          this.formData.data[tempTime[`${item}2`]] = this[item][1]
        } else {
          /* eslint-disable */ 
          this.formData.data[tempTime[`${item}1`]] = ''
          this.formData.data[tempTime[`${item}2`]] = ''
        }
      })
    },
    isDisabled(row, index) {
      if (row.recordStatus === this.recordStatusCancel) {
        return 1
      }
      return 0
    },
    rowClick(row) { // 重新该方法，处理禁用状态的行能够被勾选
      if (row.recordStatus !== this.recordStatusCancel) {
        return
      }
      this.$refs.table.toggleRowSelection(row)
      // console.log('xxx ==>', this.selection)
    },
    formatUpdateStatus(exchangeStatus) {
      return this.dic.exchangeStatus[exchangeStatus]
    },
    formatterRecordStatus(row, column, cellValue) {
      return this.dic.recordStatus[cellValue]
    },
    resetForm(formName) { // 清空 form 表单
      this.receiveTime = ''
      this.rejectTime = ''
      this.$refs[formName].resetFields()
    },
    arrayBufferToBase64(buffer) {
      return 'data:image/png;base64,' + buffer
    },
    handleChangeReciveUser() { // 变更领取人
      this.receivePersonPhone = this.selection[0].receivePersonPhone
      // 判断selection中领取人手机是否一致
      const isOnePerson = this.selection.every(item => item.receivePersonPhone === this.selection[0].receivePersonPhone)
      if (isOnePerson) {
        this.mainDialogVisible = true // 打开弹窗
      } else {
        this.handleNotify('error', '错误', '请选择同一个领取手机号用户数据')
      }
    },
    downLoadList() { // 下载列表
      this.downLoading = true
      this.$http.post(this.downLoadListUrl, this.formData.data)
        .then(res => {
          this.downLoading = false
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', '下载列表失败')
            return
          }
          if (res.data.data.file) {
            saveFile(res.data.data.fileName, res.data.data.file, 'application/xml')
          } else {
            this.handleNotify('error', '提示', '下载excel文件内容不存在')
          }
          if (res.data.data.zipFile) {
            saveFile(res.data.data.zipFileName, res.data.data.zipFile, 'application/zip')
          } else {
            this.handleNotify('error', '提示', '下载压缩包文件内容不存在')
          }
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '下载列表失败')
        })
    },
    viewRecordStatus(id) {
      this.$http.post(this.finleRecordListUrl, { recordId: id })
        .then(res => {
          const { code, data } = res.data
          if (code !== 1) {
            this.handleNotify('error', '错误', '获取配送单详细信息失败')
            return
          }
          this.recordDetailsData = data
          this.recordDetailsVisible = true
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '获取配送单详细信息失败')
        })
    },
    viewUpdateStatus(id) { // 查看领取人变更状态
      this.updataStatusVisible = true
      this.$http.post(this.findhistoryUrl, { id })
        .then(res => {
          if (res.data.code === 1) {
            this.updataStatusTabledata = res.data.data
          }
        })
    },
    handleConfirm() { // 确认变更领取人手机号
      this.$refs.dialogForm.$children[0].validate(async valid => {
        if (valid) {
          const { exchangePhone } = this.$refs.dialogForm.dialogFormData
          const selection = [...this.selection]
          let updateData = []
          let insertData = []
          selection.forEach(item => {
            updateData.push({
              id: item.id,
              rejectedPersonId: item.rejectedPersonId,
              exchangeStatus: 2,
              receivePersonPhone: exchangePhone,
              deviceName: item.deviceName,
              deliveryNumber: item.deliveryNumber,
              exchangePhone: item.receivePersonPhone,
              rejectedNumber: item.rejectedNumber,
            })
            insertData.push({
              rejecterRecordId: item.id,
              recordType: 2,
              receivePersonPhone: item.rejectedPersonPhone,
              exchangePhone,
              updateDate: new Date().getTime(),
              updateBy: ''
            })
          })
          // 先更新后插入
          const results =  await this.handleUpdate(updateData)
          if (results) { // 只有更新成功后才能进行插入操作
            this.handleInsert(insertData)
          }
        }
      })
    },
    handleUpdate(updateData) { // 更新领取人手机号
      return new Promise((resolve, reject) => {
        // console.log('this.updateUrl', this.updateUrl)
        this.$http.post(this.updateUrl, updateData)
          .then(res => {
            if (res.data.code === 1) {
              this.handleNotify('success', '提示', '变更领取人手机号成功')
              this.searchTableData()
              this.mainDialogVisible = false
              resolve(true)
            } else {
              this.handleNotify('error', '错误', res.data.msg || '变更领取人手机号失败')
              this.mainDialogVisible = false
              resolve(false)
            }
          })
          .catch(err => {
            this.handleNotify('error', '错误', err || '变更领取人手机号失败')
            reject()
          })
      })
    },
    handleInsert(insertData) { // 插入领取人手机号
      this.$http.post(this.inserRecordUrl, insertData)
        .then(res => {
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', res.data.msg || '变更领取人手机号insert操作失败')
          }
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '变更领取人手机号insert操作失败')
        })
    },
    selectionChange(selection) {
      // console.log('selection ==>', selection)
      this.selection = selection
    },
    reSendShotMessage() { // 重发短信
      const isSelectionOne = this.handleSelectOne(this.selection.length, 'reSend')
      if (!isSelectionOne) {
        return false
      }
      const param = this.selection.map(item => {
        return {
          deliveryRecordId: item.id,
          sendStatus: 0
        }
      })
      this.$http.post(this.reSendUrl, param)
        .then(res => {
          if (res.data.code === 1) {
            this.handleNotify('success', '提示', res.data.msg || '重发短信成功')
          } else {
            this.handleNotify('error', '错误', res.data.msg || '重发短信失败')
          }
        })
    },
    editPhone() { // 退料通知手机号配置
      this.editPhoneVisible = true
      this.$http.post(this.getSystemConfigUrl)
        .then(res => {
          if (res.data.code === 1) {
            this.editPhoneForm.preNoticePhone = res.data.data[0].noticePhone
          } else {
            console.error('获取系统配置接口数据失败')
          }
        })
    },
    editPhoneConfim() {
      this.$refs.editPhoneEl.validate(valid => {
        if (valid) {
          const { noticePhone } = this.editPhoneForm
          this.$http.post(this.editPhoneUrl, { noticePhone })
            .then(res => {
              if (res.data.code === 1) {
                this.handleNotify('success', '提示', '退料通知手机号配置成功')
              } else {
                this.handleNotify('error', '失败', '退料通知手机号配置失败')
              }
              this.editPhoneVisible = false
            })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .content-wrapper {
    .imgs {
      height: 30px;
      display: block; // 消除图片下方的几个像素
    }
    .el-form-item{
      margin-bottom: 0px;
    }
    /deep/.inputWidth160{
      input{
        width: 160px;
        padding: 0px 8px;
      }
      /deep/label{
        padding: 0px 6px 0px 0px;
      }
    }
    /deep/.width180{
      label{
        width: 156px !important;
      }
    }
    /deep/.width84{
      label{
        width: 84px !important;
      }
    }
    /deep/.width70{
      label{
        width: 70px !important;
      }
    }
    /deep/.btns{
      margin-left: 20px;
      text-align: center;
    }
    /deep/.inputWidth130{
      width: 130px;
    }
    /deep/.inputWidth100{
      width: 100px;
    }

    // 日历样式
    /deep/.el-icon-date{
      display: none;
    }

    .download{ // 下载列表按钮
      background: #C5B32B;
      border: none;
      color: #fff;
    }

    .updateStatus{
      cursor: pointer;
      color: rgba(0, 89, 255, 0.733);
      display: block;
      padding: 4px;
    }

    /deep/.updateStatusTable {
      td, th{
        padding: 6px 0px;
      }
    }
  }
</style>
